<template>
  <el-container>
    <el-header style="height: 70px;background-color: #FFFFFF">
      <div class="header-info">
        <img class="header-logo" src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/logo-s.png">
        <a class="company-name">广东良方药业有限公司</a>
        <div class="info-navi">
          <ul>
<!--            <li>-->
<!--              <el-link class="navi-link" href="/hy-mic-sy/home" :underline="false">首页</el-link>-->
<!--            </li>-->
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/news" style="color: #0270FF" :underline="false">行业资讯</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/about" :underline="false">关于我们
              </el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/contactUs" :underline="false">联系我们</el-link>
            </li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-main style="margin: 0 auto;padding: 0;width: 1200px; padding-top: 10px">
      <div class="main-banner">
        <el-carousel :interval="4000" height="400px" indicator-position="none">
          <el-carousel-item v-for="item in banners" :key="item" style="background-color: #FFFFFF">
            <el-image style="height: 400px;width: 1200px" :src='item.url'></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="margin-top: 20px">
        <div class="news" v-for="item in news" :key="item.id">
          <a :href="item.url" target="_blank">
            <div class="news-detail">
              <img :src="item.img">
            </div>
            <div class="news-infos">
              <h6 style="font-weight: 600;font-size: 22px">{{ item.title }}</h6>
              <p style="margin-top: 20px;line-height: 40px;text-align: left">
                {{ item.des }}
              </p>
              <p style="text-align: right;margin-top: 25px;color: #0C78D3">{{ item.createTime }}</p>
            </div>
          </a>

        </div>
      </div>

    </el-main>
    <el-footer style="height: 70px;padding-top: 40px">
      <div class="footer-info">
        <p style="line-height: 25px">
          版权所有©广东良方药业有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/xinxizheng.jpg" target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2020-0099
          </a> <br>
          ICP主体备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2022011696号-1
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/yinyezhizhao.jpg" target="_blank">营业执照副本</a>
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import Login from "@/views/login/LoginApp";

export default {
  data() {
    component:{
      Login
    }
    return {
      activeName: 'first',
      banners: [
        {
          name: 'banner2',
          url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/swiperimg0.33571a82.jpg'
        },
        {
          name: 'banner1',
          url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/swiperimg1.07be7ae5.jpg'
        }
      ],
      news: [
        {
          id: 2,
          title: '学好疼痛治疗术，哪里开诊所都不输',
          url: 'https://mp.weixin.qq.com/s/RLqtuHOwDFl-brY8JNdeDQ',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileTarSPWZw82.png',
          createTime: '2021-10-20 15:31:10',
          des: '据《中国疼痛医学发展报告(2020)》统计，我国目前至少有3亿疼痛患者，在医院门诊的就诊病人中，三分之二的病人正在或曾经受到疼痛过的困扰。然而公众在面对频频来袭的身体疼痛时，没有采取药物治疗、选择默默忍耐的患者高达40% ......'
        },
        {
          id: 3,
          title: '治疼痛，很头痛；有技术，不疼痛',
          url: 'https://mp.weixin.qq.com/s/R1coJHyQ6viEMKL7ZIk0UA',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileTTn5HWsmtE.png',
          createTime: '2021-10-20 15:30:29',
          des: '疼痛是常见病多发病，是很多疾病的入口，分散到骨科、神经内科、理疗科、康复科等。疼痛可分为头痛、颈痛、肩痛、牙痛、耳痛、胸痛、腰痛、上下肢痛、三叉神经痛、运动损伤痛等。'
        },
        {
          id: 4,
          title: '医护到家，乡镇也能轻松网约护士',
          url: 'https://mp.weixin.qq.com/s/WmL2tXldvTxdKDCWON8qPw',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileHRpJHTHfjW.png',
          createTime: '2021-10-20 15:29:24',
          des: '2018年底中国注册护士超410万，每千人口拥有护士数约2.74人，和往年相比，我国护士数量猛增，而在我国人口老龄化、医疗资源紧张、分级诊疗分配不均的情况之下，医疗市场鱼龙混杂，许多的痛点需求得不到满足，特别是在护理......'
        },
        {
          id: 5,
          title: '康华西医门诊：主推中医靠疗效收获更多粉丝',
          url: 'https://mp.weixin.qq.com/s/28jym0d5l0SKoSq3f8zKhw',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileW5hBkPbjbh.png',
          createTime: '2021-10-20 15:28:54',
          des: '基层医疗机构的中西医诊所以服务周边社区居民对常见病多发病慢病的需要为主，随着诊所申办由审批制变为备案制后，全国每年新增诊所一万五千间以上，竞争日益激烈。位于湛江市开发区平乐村第三小学附近的康华西医诊所，是由2......'
        },
        {
          id: 1,
          title: '广东省诊所基层医疗机构大数据',
          url: 'https://mp.weixin.qq.com/s/vml2n35YQgDwfwtK4fm4YQ',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file226c3WWB4K.jpg-ly',
          createTime: '2018-08-28 11:51:15',
          des: '近日，广东省卫生计生委公布“2017年度广东省卫生和计划生育统计信息简本”，对去年广东省的卫生医疗机构数目、床位数、费用、诊疗人次以及诊疗费用等方面进行统计汇总。良医小编专门为你统计全省诊所、卫生所、卫生室等基层医疗数据......'
        },
      ]
    }
  },
  methods: {}
}
</script>

<style>
.news-infos {
  width: 680px;
  height: 243px;
  padding: 20px;
  display: inline-block;
  float: left;
  color: black;
}

.news-detail img {
  width: 400px;
  height: 200px;
  border: 1px solid #dddddd;
}

.news-detail {
  width: 500px;
  padding: 20px;
  text-align: left;
  float: left;
}

.news {
  width: 1200px;
  height: 244px;
  border: 1px solid #dddddd;
  margin-top: 5px;
}

.about-us-profile h3 {
  font-weight: 600;
}

.about-us img {
  border-radius: 6px;
  width: 520px;
  height: 350px;
  float: left;
}


.product-img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.content-tiny-program-info span {
  display: inline-block;
  margin-left: 10px;
  font-size: 18px;
}

.content-tiny-program-info img {
  height: 25px;
  width: 25px;
  line-height: 30px;
}


.second-banner img {
  width: 700px;
  height: 350px;
}

.footer-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}


ul {
  display: flex;
  list-style: none;
  padding: 0;
  line-height: 40px;
  height: 70px;
  float: right;
  margin-right: 50px;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 40px;
  line-height: 70px;
}

.info-navi {
  float: right;
  width: 750px;
  height: 70px;
  text-align: right;
}

.main-banner {
}

.el-header, .el-footer {
  color: #333;
  text-align: left;
  line-height: 70px;
  height: 70px;
}

.header-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.header-logo {
  width: 65px;
  height: 65px;
  float: left;
}

.header-info .company-name {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
</style>
<style scoped>

</style>
